import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface DeleteErgonomicWorkAnalysisImageParams {
	id: string;
	image_id: string;
	organization_id: string;
	company_id: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useDeleteErgonomicWorkAnalysisImage = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: DeleteErgonomicWorkAnalysisImageParams) => Service.deleteImage(params),
		onError: () => {
			message.error(I18n.get('Error deleting image'));
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries([QUERY_KEYS.GET_ERGONOMIC_WORK_ANALYSIS]);
		}
	});
};
